<template>
  <div class="EventCategoryCard card">
    <div class="card__section">
      <ExpandableDetail>
        <template v-slot:summary>
          <h5 class="text-blue text-upper text-small">
            <span class="text-small">{{ eventCategory.name }}</span>
          </h5>

          <div class="EventCategoryCard__EmbeddedHeading with high specificity" v-html="eventCategory.descriptionHtml" />
        </template>

        <template v-slot:detail>
          <div class="card__section card__section--bordered">
            <p class="text-small text-upper">Alternate Description HTML</p>
            <div
              class="EventCategoryCard__EmbeddedContent with high specificity"
              v-html="eventCategory.alternateDescriptionHtml"
            />
          </div>

          <div class="card__section card__section--bordered">
            <p class="text-small text-upper">Documentation Description Short HTML</p>
            <div
              class="EventCategoryCard__EmbeddedContent with high specificity"
              v-html="eventCategory.documentationDescShortHtml"
            />
          </div>

          <div class="card__section card__section--bordered">
            <p class="text-small text-upper">Documentation Description Long HTML</p>
            <div
              class="EventCategoryCard__EmbeddedContent with high specificity"
              v-html="eventCategory.documentationDescLongHtml"
            />
          </div>

          <div class="card__section card__section--bordered">
            <p class="text-small text-upper">Valid ZIP codes</p>
            <p>
              {{eventCategory.validZipCodes}}
            </p>
          </div>

          <div class="card__section card__section--bordered">
            <div class="EventCategoryCard__FeatureFlag">
              <span class="EventCategoryCard__FeatureFlag__Label">
                Is Natural Disaster?
              </span>
              <span>{{ eventCategory.isNaturalDisaster ? 'YES' : 'NO' }}</span>
            </div>
          </div>

          <div class="card__section card__section--bordered">
            <p class="text-small text-upper">Required Documentation</p>
            <p>
              {{eventCategory.requiredDocumentation}}
            </p>
          </div>

        </template>
      </ExpandableDetail>
    </div>
  </div>
</template>

<script>
import FeatureFlag from '@/components/FeatureFlag'
import ExpandableDetail from '@/components/ExpandableDetail'

export default {
  name: 'EventCategoryCard',
  components: {
    FeatureFlag,
    ExpandableDetail,
  },
  props: {
    eventCategory: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins/cards';

.card {
  @include card;
}

.EventCategoryCard {
  margin-bottom: 24px;
}

.EventCategoryCard__FeatureFlag {
  display: flex;
  align-content: center;
  margin-top: 28px;
  margin-bottom: 28px;

  /** Unknown why this is needed for FeatureFlag to render correctly
      inside of a detail/summary element, but it seems to be needed **/
  box-sizing: border-box;
}

.EventCategoryCard__FeatureFlag__Label {
  margin-right: 12px;
  font-weight: bold;
}

.EventCategoryCard__EmbeddedContent {
  padding: 12px;
  border: 1px solid lightgray;
  border-radius: 8px;
  background-color: #f5f5f5;
}
</style>

<style>
.EventCategoryCard__EmbeddedHeading.with.high.specificity *,
.EventCategoryCard__EmbeddedContent.with.high.specificity * {
  margin: 0;
  padding: 0;
}

.EventCategoryCard__EmbeddedContent.with.high.specificity ul > li {
  margin-left: 22px;
}
</style>
